export class TimeoutService {
    userConfig;
    $timeout;
    log;
    timeouts = new Set();
    static $inject = ['$timeout', 'LogService'];
    constructor($timeout, logService) {
        this.userConfig = window['UserConfig'];
        this.$timeout = $timeout;
        this.log = logService.getLogger('Timeout-S', 'color: #fff; background-color: #669900', this.userConfig.TIMER_LOG_LEVEL);
    }
    register(fn, delay, invokeApply, name) {
        this.log.debug(`Registering timeout${name === undefined ? '' : ` (${name})`}`);
        const timeout = this.$timeout(fn, delay, invokeApply);
        timeout
            .then(() => this.timeouts.delete(timeout))
            .catch((reason) => {
            if (reason !== 'canceled') {
                this.log.error('Registered timeout promise rejected:', reason);
            }
        });
        timeout['_timeout_name'] = name;
        this.timeouts.add(timeout);
        return timeout;
    }
    cancel(timeout) {
        const name = timeout['_timeout_name'];
        this.log.debug(`Cancelling timeout${name === undefined ? '' : ` (${name})`}`);
        const cancelled = this.$timeout.cancel(timeout);
        this.timeouts.delete(timeout);
        return cancelled;
    }
    cancelAll() {
        this.log.debug('Cancelling ' + this.timeouts.size + ' timeouts');
        for (const timeout of this.timeouts) {
            this.$timeout.cancel(timeout);
        }
        this.timeouts.clear();
    }
}
